import type { AuthContextProps } from 'react-oidc-context';

import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { LayoutAndProvidersWrapper } from '@/components';

type RouteContext = {
  auth: AuthContextProps;
  portableMode: boolean | undefined;
};
export const Route = createRootRouteWithContext<RouteContext>()({
  // head: () => ({links: [...fonts]}),
  beforeLoad: ({ context: { auth, portableMode } }) => {
    if (!portableMode) return;
    if (!auth.isAuthenticated) {
      throw auth.signinRedirect();
    }
  },
  component: () => (
    <LayoutAndProvidersWrapper>
      <Outlet />
      {/*<TanStackRouterDevtools />*/}
      {/*<ReactQueryDevtoolsPanel />*/}
    </LayoutAndProvidersWrapper>
  ),
});
